/** Shared caisse helpers — Centre Activité HUB-D. */

export const CAISSE_SECTIONS = {
  JOURNALIER: 'journalier',
  MENSUEL: 'mensuel',
};

export function formatCaisseDateTime(value) {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return d.toLocaleString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatEuro(value) {
  return `${Number(value || 0).toFixed(2)} €`;
}

export function ecartClass(ecart) {
  const n = Number(ecart || 0);
  if (n >= 0) return 'text-[var(--rm-success)]';
  return 'text-[var(--rm-red-light)]';
}

export function sessionStatusMeta(caisse) {
  if (!caisse.heure_fermeture) {
    return { label: 'Ouverte', badge: 'rm-badge rm-badge--success' };
  }
  if (caisse.force_closed) {
    return { label: 'Fermée (forcée)', badge: 'rm-badge rm-badge--danger' };
  }
  return { label: 'Fermée', badge: 'rm-badge rm-badge--muted' };
}

export function matchesCaisseSearch(item, search) {
  if (!search?.trim()) return true;
  const q = search.trim().toLowerCase();
  const haystack = [
    item.date_caisse,
    item.magasin_id,
    item.opened_by,
    item.closed_by,
    item.user_ouverture,
    item.user_fermeture,
    item.validated_by,
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
  return haystack.includes(q);
}

export function computeCaisseKpis(sessions = [], monthlyRows = []) {
  const closed = sessions.filter((s) => s.heure_fermeture);
  const openCount = sessions.filter((s) => !s.heure_fermeture).length;
  const totalVentes = sessions.reduce((acc, s) => acc + Number(s.total_ventes || 0), 0);
  const totalRetraits = sessions.reduce((acc, s) => acc + Math.abs(Number(s.total_retraits || 0)), 0);
  const totalCoffre = closed.reduce((acc, s) => acc + Number(s.montant_coffre || 0), 0);
  const ecartSum = closed.reduce((acc, s) => acc + Number(s.ecart || 0), 0);

  return {
    openCount,
    sessionCount: sessions.length,
    monthlyCount: monthlyRows.length,
    totalVentes,
    totalRetraits,
    totalCoffre,
    ecartSum,
  };
}

export function caisseHistoriqueLinkFromFilters(filters) {
  const params = new URLSearchParams();
  if (filters?.date_debut) params.set('date_debut', filters.date_debut);
  if (filters?.date_fin) params.set('date_fin', filters.date_fin);
  if (filters?.magasin_id) params.set('magasin_id', filters.magasin_id);
  const qs = params.toString();
  return qs ? `/caisse-historique?${qs}` : '/caisse-historique';
}

export function activiteCaisseLinkFromFilters(filters) {
  const params = new URLSearchParams({ tab: 'caisse' });
  if (filters?.search) params.set('search', filters.search);
  if (filters?.date_debut) params.set('date_debut', filters.date_debut);
  if (filters?.date_fin) params.set('date_fin', filters.date_fin);
  if (filters?.magasin_id) params.set('magasin_id', filters.magasin_id);
  if (filters?.period) params.set('period', filters.period);
  return `/activite?${params.toString()}`;
}
